export default "__VITE_ASSET__Cj7Ks3fW__"